import { FC } from "react";
import { MainMenu } from "../MainMenu/MainMenu";
import { useMainStore } from "@/store/main";
import { SidebarToggleIcon } from "@/components/Icons/SidebarToggleIcon";
import { MobileNav } from "../MobileNav/MobileNav";
import { useMediaQueryMatch } from "@/hooks/useMediaQueryMatch";
import { AppHeaderActions } from "@/components/Common/AppHeader/AppHeaderActions";
import env from "@/env";

export const MainHeader: FC = () => {
  const toggleAppContentWidthMode = useMainStore((state) => state.toggleAppContentWidthMode);
  const toggleMobileSidebarSheet = useMainStore((state) => state.toggleMobileSidebarSheet);
  const isMdUp = useMediaQueryMatch("md");

  return (
    <div className="z-30">
      {/* <MaintenanceAnnouncementBanner /> */}
      <div
        className="overflow-x-auto flex flex-row items-center gap-1 px-4 py-3 pl-4 md:pl-0 dark:border-b-gray-dark-500 md:gap-3 md:h-[68px]"
        data-testid={"MainHeader_wrapper"}
      >
        <button
          type="button"
          onClick={() => {
            if (isMdUp) {
              toggleAppContentWidthMode();
            } else {
              toggleMobileSidebarSheet();
            }
          }}
          aria-label={isMdUp ? "Toggle app width mode" : "Open navigation menu"}
          title={isMdUp ? "Toggle app width mode" : "Open navigation menu"}
          className={`_mr-auto relative mr-1 flex size-[36px] shrink-0 items-center justify-center rounded-[8px] border border-border bg-background text-foreground shadow-[-8px_8px_8px_0px_rgba(0,0,0,0.02)] transition-colors hover:bg-accent ${env.FEATUREFLAG_FULL_WIDTH_TOGGLE_ENABLED ? "max-md:hidden" : "hidden"}`}
        >
          <SidebarToggleIcon className="size-[20px]" />
        </button>

        <div className="flex flex-row items-center gap-1 md:gap-3 flex-1 justify-end">
          <AppHeaderActions />
        </div>

        <div className="lg:hidden">
          <MobileNav />
        </div>
      </div>
      <MainMenu />
    </div>
  );
};
